import React, { ComponentType, useCallback } from "react";

import BaseWizard, { BaseWizardProps } from "@app/component/wizard/components/BaseWizard";
import IWizardStep from "@app/component/wizard/types/IWizardStep";

export interface MultiStepWizardProps<T> extends Omit<
  BaseWizardProps<T>,
  "onGetStep" | "stepsCount"
> {
  steps: ComponentType<IWizardStep<T>>[];
}

const MultiStepWizard = <T,>({ steps, ...props }: MultiStepWizardProps<T>) => {
  const handleGetStep = useCallback((index: number) => steps[index], [steps]);

  return <BaseWizard {...props} onGetStep={handleGetStep} stepsCount={steps.length} />;
};

export default MultiStepWizard;
